import * as Yup from "yup";

/**
 * Dobavljač se unosi samo kroz kontakte — naziv, OIB i adresa dolaze s odabranog kontakta, pa je
 * veza s njim ono što račun mora imati.
 */
export const INVOICE_INCOMING_EDIT_FORM_SCHEMA = Yup.object().shape({
  invoiceNumber: Yup.string().nullable().required("Broj računa je obavezan"),
  invoiceDate: Yup.date().nullable().required("Datum računa je obavezan"),
  contactSupplierId: Yup.string().nullable().required("Odaberite dobavljača"),
});
